import { Card } from "react-bootstrap";
import styled from "styled-components";

const StyledProfessionalPractice = styled.div`
    font-size: 15px;
    color: #404040;
    text-align: initial;
`;

const StyledHour = styled.div`
    font-size: 15px;
    color: #9654ff;
    text-align: end;
`;

const StyledCourse = styled.div`
    font-weight: 400;
    font-size: 15px;
    text-align: initial;
    color: #787878;
    margin-bottom: 25px;
`;

const StyledCardGrey = styled(Card)`
    border: none;
    border-radius: 8px;
    background: #f0f2f2;
`;

const StyledDetails = styled.div`
    font-size: 16px;
    align-items: initial;
    color: #404040;
    width: 100%;
    display: flex;
`;

const StyledInfoLabel = styled.div`
    font-weight: 400;
    font-size: 12px;
    display: flex;
    align-items: center;
    color: #787878;
    width: 100%;
`;

const StyledInfoText = styled.div`
    font-weight: 400;
    font-size: 17px;
    display: flex;
    align-items: center;
    color: #404040;
    width: 100%;
    text-align: initial;
`;

const StyledAlertStatus = styled.div`
    display: flex;
    background-color: #fffdd9;
    border-radius: 16px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    align-items: center;
    margin-top: 20px;
`;

const StyledAlertText = styled.p`
    color: #1e1e1e;
    font-size: 17px;
    margin: 0;
    padding: 16px 0;
`;

export {
    StyledProfessionalPractice,
    StyledHour,
    StyledCourse,
    StyledCardGrey,
    StyledDetails,
    StyledInfoLabel,
    StyledInfoText,
    StyledAlertStatus,
    StyledAlertText,
};
